(() => {
  const DESKTOP_THRESHOLD = 4;
  const MOBILE_THRESHOLD = 2;
  const DESKTOP_BREAKPOINT = 990;

  const initProductAwards = (section) => {
    if (!section || !section.classList.contains("section-product-awards"))
      return;

    const container = section.querySelector(".at-product-awards");
    if (!container) return;

    const grid = container.querySelector("[data-awards-grid]");
    const slider = container.querySelector("[data-awards-slider]");
    const count = parseInt(container.dataset.awardsCount, 10) || 0;

    if (!grid || !slider) return;

    const updateView = () => {
      const isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
      const threshold = isDesktop ? DESKTOP_THRESHOLD : MOBILE_THRESHOLD;
      const showSlider = count > threshold;

      grid.style.display = showSlider ? "none" : "";
      slider.style.display = showSlider ? "" : "none";
    };

    updateView();

    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateView, 100);
    });
  };

  initProductAwards(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", (event) => {
    initProductAwards(event.target);
  });
})();
